import React from 'react';
import PropTypes from 'prop-types';
import { FeatureDrawer } from '../../../../knock-design-system';
import { CloneProperty } from './CloneProperty';
import { ManageChannels } from './ManageChannels';
import { ShowHideChannels } from './ShowHideChannels';
import { DRAWER_MODES, DRAWER_TITLES } from '../constants';

export const SyndicationDrawer = ({ drawerMode, handleDrawerMode }) => {
  return (
    <FeatureDrawer
      closeDrawer={handleDrawerMode(null)}
      isOpen={Boolean(drawerMode)}
      title={DRAWER_TITLES[drawerMode]}
    >
      {drawerMode === DRAWER_MODES.MANAGE && (
        <ManageChannels handleDrawerMode={handleDrawerMode} />
      )}

      {drawerMode === DRAWER_MODES.CLONE && (
        <CloneProperty handleDrawerMode={handleDrawerMode} />
      )}

      {drawerMode === DRAWER_MODES.FILTER && (
        <ShowHideChannels handleDrawerMode={handleDrawerMode} />
      )}
    </FeatureDrawer>
  );
};

SyndicationDrawer.propTypes = {
  drawerMode: PropTypes.oneOf([
    null,
    DRAWER_MODES.CLONE,
    DRAWER_MODES.FILTER,
    DRAWER_MODES.MANAGE,
  ]),
  handleDrawerMode: PropTypes.func,
};
